module.exports = __webpack_public_path__ + "img/peru_awajun_02.1b29c5ae.png";